export const packDescriptions: any = {
	pack_common_1:
		"This Mystery Pack contains 1 game board and 2 random items. You can find amongst them unique generative characters with random stats, pets that you can grow, over 50 power ups and more!",
	pack_rare_1:
		"This Mystery Pack contains 1 game board and 4 random items. You can find amongst them unique generative characters with random stats, pets that you can grow, over 50 power ups and more! A secret gift is also inside.",
	pack_legendary_1:
		"This Mystery Pack contains 1 game board and 6 random items. You can find amongst them unique generative characters with random stats, pets that you can grow, over 50 power ups and more! A secret gift is also inside, as well as a coupon for upcoming Nintendo Switch game.",
};
